import { IDynamicQueryService } from "../../service/dynamicQuery/DynamicQueryService";
import { IDynamicQuery } from "../../model/dynamicQuery/DynamicQuery";

export default class CreateDynamicQueryInteractor {
  private dynamicQueryService: IDynamicQueryService;

  constructor(dynamicQueryService) {
    this.dynamicQueryService = dynamicQueryService;
  }

  async execute(dynamicQuery: IDynamicQuery) {
    return this.dynamicQueryService.createDynamicQuery(dynamicQuery);
  }
}
